// extracted by mini-css-extract-plugin
export default {"oosNotify":"N7-z","count":"O7-z","otherColors":"P7-z","modalContent":"Q7-z","body":"R7-z"};